import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { myAccountActions } from "../../../_store";
import { authActions } from "../../../_store";
import { decryptDataPublicLogin } from "../../../utils/encryptDecrypt";
import { getStoredValue } from "../../../_helpers/storagehelper";

const ValidateUser = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const triggerApiCall = () => {
      const publicUserID = getStoredValue("userID");
      const PUPasswordLogID = getStoredValue("PUPasswordLogID");

      if (publicUserID && PUPasswordLogID && location.pathname !== "/public/Login") {
        dispatch(myAccountActions.PublicUserValidateLoginDetails({ publicUserID, PUPasswordLogID }))
          .then((response) => {
            const result = response?.payload?.[0];
            if (result?.IsSucced === 0) {
              dispatch(myAccountActions.clearPublicUserLoginStatusResponse());
              dispatch(authActions.clearEmailResponse());
              // dispatch(authActions.logout());
              // navigate("/public/Login");
              const decryptPassword = decryptDataPublicLogin(result?.DecryptedPassword);

              navigate("/public/Login", {
                state: {
                  username: result.UserName,
                  password: decryptPassword,
                },
              });
            } else if (result === undefined) {
              navigate("/public/Login");
            }
          })
          .catch((error) => {
            console.error("Error in API call:", error);
          });
      }
    };

    // Initial check on mount
    triggerApiCall();

    // Polling every 5 seconds

    const intervalId = setInterval(triggerApiCall, 900000);
    // const intervalId = setInterval(triggerApiCall, 200000);

    return () => clearInterval(intervalId);
  }, [dispatch, location.pathname, navigate]);

  return null;
};

export default ValidateUser;
